export const MY_DATA_MODULES = [
  {
    title: 'Organization Data',
    type: 'organization',
    url: '',
  },
  {
    title: 'Module Data',
    type: 'module',
    url: '',
  },
]

export const sortByYear = list => {
  return [...list].sort((a, b) => Number(a.year) - Number(b.year))
}

/**
 * Sorts an array of objects by the effectiveDate property in descending order.
 * @param {Array} array The array to sort.
 * @returns {Array} A new array sorted in descending order by effectiveDate.
 */
export const sortByEffectiveDateDescending = array => {
  return array.sort((a, b) => {
    const dateATime = new Date(a.effectiveDate).getTime()
    const dateBTime = new Date(b.effectiveDate).getTime()
    return dateBTime - dateATime
  })
}
